import { BranchGetAllAdapter } from '../../../../adapter';

export default async function BranchGetAllUseCase(event) {
    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/branch/get-all';

    const result = await BranchGetAllAdapter(requestUrl, null);
    return result;
}
